import Dexie, { type Table } from "dexie";

import type { ReportCreate, ReportOut } from "../../features/reports/api";
import type { StationCreate, StationOut } from "../../features/stations/api";

export type Endpoint = "POST /reports" | "POST /stations" | "POST /favorites" | "DELETE /favorites";

// Maps each endpoint to its body shape so enqueue can be statically typed
// per-call without callers casting through Record<string, unknown>.
export type BodyByEndpoint = {
  "POST /reports": ReportCreate;
  "POST /stations": StationCreate;
  "POST /favorites": { station_id: string };
  "DELETE /favorites": { station_id: string };
};

// Mirror of BodyByEndpoint for the dispatch response shape.
export type ResponseByEndpoint = {
  "POST /reports": ReportOut;
  "POST /stations": StationOut;
  "POST /favorites": void;
  "DELETE /favorites": void;
};

export type OutboxItem = {
  id?: number;
  endpoint: Endpoint;
  // Path params (e.g., the station id for /favorites/:id) live in the body
  // alongside the JSON payload. The transport layer assembles the URL.
  body: Record<string, unknown>;
  createdAt: number;
  tries: number;
};

class VoltaRouteDexie extends Dexie {
  outbox!: Table<OutboxItem, number>;

  constructor() {
    super("voltaroute");
    this.version(1).stores({
      outbox: "++id, endpoint, createdAt",
    });
  }
}

let db: VoltaRouteDexie | null = null;

export function getDb(): VoltaRouteDexie {
  if (!db) db = new VoltaRouteDexie();
  return db;
}

export function resetDbForTests(): void {
  db = null;
}
